

/// <reference path="LegalEntity.ts" />

// Generated class Supplier_ManagedObject

class Supplier_ManagedObject extends LegalEntity
{

    // Property: autoValidateSupplierOrder
    set autoValidateSupplierOrder(value:boolean) {
        this.setValueForKey(value, 'autoValidateSupplierOrder');
    }
    get autoValidateSupplierOrder():boolean {
        return this.valueForKey('autoValidateSupplierOrder');
    }
    set autoValidateSupplierOrderPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'autoValidateSupplierOrder');
    }
    get autoValidateSupplierOrderPrimitiveValue():boolean {
        return this.primitiveValueForKey('autoValidateSupplierOrder');
    }

    // Property: emailOrders
    set emailOrders(value:string) {
        this.setValueForKey(value, 'emailOrders');
    }
    get emailOrders():string {
        return this.valueForKey('emailOrders');
    }
    set emailOrdersPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'emailOrders');
    }
    get emailOrdersPrimitiveValue():string {
        return this.primitiveValueForKey('emailOrders');
    }

    // Property: onlineURL
    set onlineURL(value:string) {
        this.setValueForKey(value, 'onlineURL');
    }
    get onlineURL():string {
        return this.valueForKey('onlineURL');
    }
    set onlineURLPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'onlineURL');
    }
    get onlineURLPrimitiveValue():string {
        return this.primitiveValueForKey('onlineURL');
    }

    // Property: onlySupplierProducts
    set onlySupplierProducts(value:boolean) {
        this.setValueForKey(value, 'onlySupplierProducts');
    }
    get onlySupplierProducts():boolean {
        return this.valueForKey('onlySupplierProducts');
    }
    set onlySupplierProductsPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'onlySupplierProducts');
    }
    get onlySupplierProductsPrimitiveValue():boolean {
        return this.primitiveValueForKey('onlySupplierProducts');
    }
    // Relationship: integratorConfig
    set integratorConfig(value:IntegratorConfig) {
        this.setValueForKey(value, 'integratorConfig');
    }
    get integratorConfig():IntegratorConfig {
        return this.valueForKey('integratorConfig') as IntegratorConfig;
    }

    // Relationship: supplierProducts
    protected _supplierProducts:MIOManagedObjectSet = null;
    get supplierProducts():MIOManagedObjectSet {
        return this.valueForKey('supplierProducts');
    }
    addSupplierProductsObject(value:SupplierProduct) {
        this._addObjectForKey(value, 'supplierProducts');
    }
    removeSupplierProductsObject(value:SupplierProduct) {
        this._removeObjectForKey(value, 'supplierProducts');
    }
}
